import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ReportsService } from 'src/app/reports/reports.service';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-view-cma-more',
  templateUrl: './view-cma-more.component.html',
  styleUrls: ['./view-cma-more.component.scss'],
})
export class ViewCmaMoreComponent implements OnInit {
  cmaViewDetails: any;
  onDestroyNotifier$ = new Subject();
  userRole: string;
  createdBy: any;
  portfolio: any;
  nvLicenseList: Array<any> = [];
  connectedUsers: any;
  reportType: any;

  constructor(private cmaState: CmaState, private appState: AppState, private userState: UserState, private reportsService: ReportsService) { }

  ngOnInit(): void {
    this.reportType = this.appState.companyInfoValue.appConfig?.cmaReport?.displayName ? this.appState.companyInfoValue.appConfig.cmaReport.displayName : 'CMA';
    this.cmaState.cmaReports.pipe().subscribe((res: any) => {
      if (res) {
        this.cmaViewDetails = res;
        if (this.cmaViewDetails.createdUserInfo) {
          this.createdBy = this.cmaViewDetails.createdUserInfo;
          this.userRole = this.createdBy.roles[0];
        }
        if (this.userRole && this.userRole.includes('investor')) {
          this.reportsService.getConnectedUsers();
          this.userState.connectedUsers.subscribe((data) => {
            this.connectedUsers = data;
          });
        }
        if (this.createdBy && this.createdBy.portfolio && Object.keys(this.createdBy.portfolio).length) {
          this.portfolio = this.createdBy.portfolio;
        }
        if (this.createdBy && this.createdBy.nvLicenseList && this.createdBy.nvLicenseList.length) {
          this.nvLicenseList = this.createdBy.nvLicenseList;
        }
      }
    });
  }
}
